import { apiQuery } from '../';

export const ProjectsQuery = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getInternalTeamProjects: builder.query({
        providesTags: ['GetProjectsInternalUsers'],
        transformResponse: (response) => response?.data,
        query: ({ projectId }) => {
          return {
            method: 'get',
            url: `/projects/${projectId}/internal_users`,
          };
        },
      }),
      getExternalTeamProjects: builder.query({
        providesTags: ['GetProjectsExternalUsers'],
        transformResponse: (response) => response?.data,
        query: ({ projectId }) => {
          return {
            method: 'get',
            url: `/projects/${projectId}/external_users`,
          };
        },
      }),
      projectList: builder.query({
        transformResponse: (response) => response?.data?.projects,
        query: () => {
          return {
            method: 'get',
            url: `/projects/list`,
          };
        },
      }),
      createProject: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          return {
            url: '/projects',
            method: 'post',
            data: { ...payload },
          };
        },
      }),
      updateProject: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ projectId, ...rest }) => {
          return {
            url: `/projects/${projectId}`,
            method: 'put',
            data: { ...rest },
          };
        },
        invalidatesTags: [
          'GetProjectsInternalUsers',
          'GetProjectsExternalUsers',
        ],
      }),
      cloneProject: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ projectId, ...rest }) => {
          return {
            method: 'post',
            url: `/projects/${projectId}/clone`,
            data: { ...rest },
          };
        },
      }),
      archiveProject: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ projectId }) => {
          return {
            method: 'put',
            url: `/projects/${projectId}/archive`,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useCreateProjectMutation,
  useUpdateProjectMutation,
  useArchiveProjectMutation,
  useCloneProjectMutation,
  useProjectListQuery,
  useGetInternalTeamProjectsQuery,
  useGetExternalTeamProjectsQuery,
} = ProjectsQuery;
